import { PluginContainerData } from "./common";
import { HTMLData_Source } from "./plugin_html.enums";
function hTMLData_SourceFromJSON(object) {
  switch (object) {
    case 0:
    case "HTML":
      return HTMLData_Source.HTML;
    case 1:
    case "ADSENSE":
      return HTMLData_Source.ADSENSE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HTMLData_Source.UNRECOGNIZED;
  }
}
function hTMLData_SourceToJSON(object) {
  switch (object) {
    case HTMLData_Source.HTML:
      return "HTML";
    case HTMLData_Source.ADSENSE:
      return "ADSENSE";
    default:
      return "UNKNOWN";
  }
}
const baseHTMLData = { source: HTMLData_Source.HTML };
const HTMLData = {
  fromJSON(object) {
    const message = { ...baseHTMLData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.url = object.url !== void 0 && object.url !== null ? String(object.url) : void 0;
    message.html = object.html !== void 0 && object.html !== null ? String(object.html) : void 0;
    message.isAdsense = object.isAdsense !== void 0 && object.isAdsense !== null ? Boolean(object.isAdsense) : void 0;
    message.source = object.source !== void 0 && object.source !== null ? hTMLData_SourceFromJSON(object.source) : HTMLData_Source.HTML;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.url !== void 0 && (obj.url = message.url);
    message.html !== void 0 && (obj.html = message.html);
    message.isAdsense !== void 0 && (obj.isAdsense = message.isAdsense);
    message.source !== void 0 && (obj.source = hTMLData_SourceToJSON(message.source));
    return obj;
  }
};
export {
  HTMLData,
  hTMLData_SourceFromJSON,
  hTMLData_SourceToJSON
};
//# sourceMappingURL=plugin_html.js.map
